var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button, FormController, FormLabel, Input, LoadingButton, Modal, ModalBody, ModalFooter, ModalHeader, Typography, } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState } from 'react';
import { editPOJobName } from '../../../api/oms/order-history';
import { ERR_GENERIC } from '../../../constants/response-error-messages';
import { setEditJobNameError, } from '../../../utils/purchase-history/analytics';
import { getSvocId } from '../../../utils/user';
export var PoJobNameModal = function (_a) {
    var _b = _a.order, orderNumbers = _b.orderNumbers, _c = _b.POJobName, POJobName = _c === void 0 ? '' : _c, registerNumber = _b.registerNumber, salesDate = _b.salesDate, storeNumber = _b.storeNumber, transactionId = _b.transactionId, orderNumber = _b.orderNumber, openModal = _a.openModal, setOpenModal = _a.setOpenModal, _d = _a.visiblePoJobName, visiblePoJobName = _d === void 0 ? '' : _d, setVisiblePoJobName = _a.setVisiblePoJobName, setAlertState = _a.setAlertState;
    var _e = useState(visiblePoJobName === 'Add PO/Job Name' ? '' : visiblePoJobName), jobName = _e[0], setJobName = _e[1];
    var _f = useState({
        error: { invalidChar: false, invalidLength: false },
        showApiError: false,
        showInputError: false,
        showInputSuccess: false,
        showIsLoading: false,
    }), inputSettings = _f[0], setInputSettings = _f[1];
    useEffect(function () {
        var invalidChars = /[$&+,:;=\\?@(){}~%#\][|/'<>.^*()%!-]/;
        if (invalidChars.test(jobName) && jobName.length > 0) {
            setInputSettings(function (prev) { return (__assign(__assign({}, prev), { showInputError: true, showApiError: false, error: __assign(__assign({}, prev.error), { invalidChar: true }) })); });
            return;
        }
        if (jobName.length > 0 && jobName !== 'Add PO/Job Name') {
            setInputSettings(function (prev) { return (__assign(__assign({}, prev), { showInputSuccess: true, showInputError: false, showApiError: false, error: { invalidChar: false, invalidLength: false } })); });
            return;
        }
        if (inputSettings.showInputSuccess && jobName.length === 0) {
            setInputSettings(function (prev) { return (__assign(__assign({}, prev), { showInputError: false, error: { invalidChar: false, invalidLength: false } })); });
        }
    }, [jobName]);
    var closeModal = function () {
        setOpenModal(false);
        setJobName('');
        setInputSettings(function (prev) { return (__assign(__assign({}, prev), { showInputError: false, showApiError: false })); });
    };
    var onFormSubmit = function (action) { return __awaiter(void 0, void 0, void 0, function () {
        var itemOrderNumber, request, response, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, 3, 4]);
                    setInputSettings(function (prev) { return (__assign(__assign({}, prev), { showInputError: false, showApiError: false, showIsLoading: true, error: { invalidChar: false, invalidLength: false } })); });
                    itemOrderNumber = (_b = (_a = orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) !== null && _a !== void 0 ? _a : orderNumber) !== null && _b !== void 0 ? _b : '';
                    request = {
                        editPoJobNameRequest: {
                            customerAccountId: getSvocId(),
                            purchaserId: getSvocId(),
                            orderNumber: itemOrderNumber,
                            registerNumber: registerNumber !== null && registerNumber !== void 0 ? registerNumber : 0,
                            salesDate: salesDate !== null && salesDate !== void 0 ? salesDate : '',
                            storeNumber: storeNumber !== null && storeNumber !== void 0 ? storeNumber : 0,
                            transactionId: transactionId !== null && transactionId !== void 0 ? transactionId : 0,
                            newPOJobName: action === 'delete' ? '' : jobName,
                        },
                    };
                    return [4 /*yield*/, editPOJobName(request)];
                case 1:
                    response = _c.sent();
                    if (response.data.editPOJobNameStatus) {
                        setVisiblePoJobName(action === 'delete' ? 'Add PO/Job Name' : jobName);
                        if (setAlertState) {
                            setAlertState({
                                status: 'success',
                                alertMessage: 'PO/Job Name Saved',
                                onClose: function () { return setAlertState(null); },
                            });
                        }
                        setOpenModal(false);
                    }
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _c.sent();
                    setEditJobNameError(error_1);
                    setInputSettings(function (prev) { return (__assign(__assign({}, prev), { showApiError: true, showIsLoading: false })); });
                    return [3 /*break*/, 4];
                case 3:
                    setInputSettings(function (prev) { return (__assign(__assign({}, prev), { showIsLoading: false })); });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var inputStatus = function () {
        if (inputSettings.showInputError)
            return 'error';
        if (inputSettings.showInputSuccess)
            return 'success';
        if (inputSettings.showApiError)
            return 'error';
        return '';
    };
    return (React.createElement("div", { "data-testid": "editPOJobNameModal" },
        React.createElement(Modal, { open: openModal, onClose: closeModal, size: "sm" },
            React.createElement(ModalHeader, { onClose: closeModal }, POJobName === (orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) || POJobName === ''
                ? 'Add PO/Job Name'
                : 'Edit PO/Job Name'),
            React.createElement(ModalBody, null,
                React.createElement(FormController, { className: "sui-mt-6", fullWidth: true, status: inputStatus() },
                    React.createElement(FormLabel, { htmlFor: "jobName" },
                        "PO/Job Name",
                        React.createElement("sup", null, "*")),
                    React.createElement(Input, { "aria-describedby": "jobName-input", fullWidth: true, id: "jobName", onChange: function (event) {
                            setJobName(event.target.value);
                        }, value: jobName, placeholder: "Enter PO/Job Name" }),
                    (inputSettings.showInputError || inputSettings.showApiError) && (React.createElement(Typography, { variant: "body-xs", color: "danger" },
                        inputSettings.error.invalidChar &&
                            'Only letters and numbers are allowed.',
                        inputSettings.error.invalidLength &&
                            'Please enter a PO/Job Name',
                        inputSettings.showApiError && ERR_GENERIC.message)))),
            React.createElement(ModalFooter, { position: "end" },
                React.createElement("div", { className: "ButtonGroup sui-min-w-full sui-flex sui-gap-4 sui-flex-col-reverse md:sui-flex-row lg:sui-flex-row" },
                    React.createElement(Button, { disabled: visiblePoJobName === '' ||
                            visiblePoJobName === 'Add PO/Job Name', variant: "secondary", fullWidth: true, onClick: function () { return onFormSubmit('delete'); } }, "Delete"),
                    React.createElement(LoadingButton, { fullWidth: true, loading: inputSettings.showIsLoading, onClick: function () { return onFormSubmit('update'); }, variant: "primary", disabled: inputSettings.showInputError || inputSettings.showApiError }, "Submit"))))));
};
